import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import ThrottlingCheckbox from "integrations/components/ThrottlingCheckbox";
import AdditionalFields from "integrations/aws/common/AdditionalFields";
import FormDataContext from "integrations/contexts/FormDataContext";
import { AdvancedOptionsContext } from "./context/AdvancedOptions";
const FormAdvancedOptions = ({ onChange }) => {
  const { t } = useTranslation("enterprise_integrations");
  const { formData } = useContext(FormDataContext);
  const { isAdvancedOptionsVisible, setAdvancedOptionsVisibility } = useContext(AdvancedOptionsContext);
  const { workspaceThrottleEnabled } = formData;
  const handleToggle = (visible) => {
    setAdvancedOptionsVisibility(visible);
  };
  return /* @__PURE__ */ React.createElement(
    AdditionalFields,
    {
      title: t("common.fields.advanced_options"),
      visible: isAdvancedOptionsVisible,
      onToggle: handleToggle
    },
    /* @__PURE__ */ React.createElement(
      ThrottlingCheckbox,
      {
        id: "wrokspaceThrottleEnabled",
        defaultChecked: workspaceThrottleEnabled == null ? void 0 : workspaceThrottleEnabled.value,
        onChange
      }
    )
  );
};
export default FormAdvancedOptions;
